/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const algorand_chain_about = () => `Algorand emerges as a blockchain platform committed to fostering transparency and enabling the growth of decentralized projects and applications. Operating as a public, decentralized blockchain, it leverages a Pure Proof-of-Stake (PPoS) consensus mechanism to uphold network security, efficiency, and decentralization. Powered by the Algorand Consensus Algorithm, the network employs a combination of cryptographic techniques and random selection to attain consensus, effectively addressing the constraints of traditional consensus mechanisms.`
